import { useEffect } from 'react';

import { AppProvider } from './app/AppProvider';
import { AppRoutes } from './app/AppRoutes';
import ContactPopup from './components/ContactPopup';
import CookiesPopup from './features/home/components/CookiesPopup';
import { initCampaignTracking } from './utils/campaign-service';

function App() {
  useEffect(() => {
    initCampaignTracking();
  }, []);

  return (
    <AppProvider>
      <AppRoutes />
      <ContactPopup />
      <CookiesPopup />
    </AppProvider>
  );
}

export default App;
